import { type ModuleId } from '@autone/redux/data-ingestion';
import { useAutoneTranslation } from '@autone/translations';

import { Card } from '../../../../atoms';
import { type AutoneIconComponent } from '../../../../icons';
import { cn } from '../../../../utils';
import { BadgeListWithOverflow } from '../../../BadgeListWithOverflow';
import { moduleIdTranslationKeyMap } from '../data-freshness-popover/data-freshness-popover-content/utils/application-id-translation-key-map';
import { type DatasetDataFreshnessStatus } from '../DataFreshnessWidget.types';
import { getFreshnessStatusTextColor } from '../utils';

interface DataSourceFreshnessCardProps {
  Icon: AutoneIconComponent;
  label: string;
  formattedAge: string;
  status?: DatasetDataFreshnessStatus;
  impactedModules: ModuleId[];
}

export const DataSourceFreshnessCard = ({
  Icon,
  label,
  formattedAge,
  status,
  impactedModules,
}: DataSourceFreshnessCardProps) => {
  const { common } = useAutoneTranslation();

  const translatedImpactedModules = impactedModules.map((id) =>
    common(moduleIdTranslationKeyMap[id]),
  );

  return (
    <Card className="p-2.5">
      <div className="flex items-start gap-4">
        <div className="flex-1">
          <div
            className={cn(
              'flex items-center gap-2 align-baseline text-sm text-muted-foreground',
              status && getFreshnessStatusTextColor(status),
            )}
          >
            <Icon size="sm" />
            <span className="first-letter:uppercase text-foreground">
              {label}:
            </span>
            <span>{formattedAge}</span>
          </div>
          <div className="mt-1 flex gap-2 items-baseline">
            <div className="text-xs">
              {common(
                'data-age.global-widget.details-sidesheet.modules-impacted',
              )}
            </div>
            <BadgeListWithOverflow
              items={translatedImpactedModules}
              maxVisible={4}
            />
          </div>
        </div>
      </div>
    </Card>
  );
};
